export default "__VITE_ASSET__Y0JvP0dv__"